import React, { useState, useEffect } from 'react';
import useTranslation from 'Hooks/useTranslation';
import { TextField, MenuItem } from '@mui/material';
import Alert from 'Components/Alert';
import Modal from 'Components/Modal';
import Options from 'Components/Options';
import { MoreVert } from '@mui/icons-material';
import ModalInformation from '../../Components/ModalInformation';
import Title from '../../Components/Title';
import useModule from '../../Hooks/useModule';
import { nameStyle } from './style';

function ModuleData({ deleteModule, updateModule, module, alert, setAlert }) {
  const { t2 } = useTranslation('EditCourse');
  const [alertMessage, setAlertMessage] = useState(alert || '');
  const [alertOpen, setAlertOpen] = useState(false);
  const [unchanged, setUnchanged] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (alert) {
      setAlertMessage(t2(`${alert}`));
      setAlertOpen(true);
      setTimeout(() => {
        setAlert('');
      }, 2000);
    }
  }, [alert]);

  const { name, setName, isDraft, setIsDraft, moduleUpdate, moduleDelete, numberLessons } = useModule({
    module,
    deleteModule,
    updateModule,
    moduleId: module.id,
  });

  const handleClick = async () => {
    setOpenModal(false);
    moduleUpdate();
    setAlertOpen(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <div>
      <Title
        name={name}
        check={isDraft}
        setCheck={setIsDraft}
        setUnchanged={setUnchanged}
        checkDisabled={numberLessons === 0}
        checkText={t2('Draft')}
        checkInfo={t2('DraftCondition')}
        textButton={t2('Save')}
        setOpenModal={setOpenModal}
        buttonDisabled={unchanged}
      >
        <Options Icon={<MoreVert />} disabledEffect>
          <MenuItem onClick={moduleDelete}>{t2('DeleteModule')}</MenuItem>
        </Options>
      </Title>
      <TextField
        label={t2('ModuleName')}
        color="MexlogGreen"
        defaultValue={name}
        onChange={e => {
          setName(e.target.value);
          setUnchanged(false);
        }}
        style={nameStyle}
      />
      <Modal
        open={openModal}
        setOpen={setOpenModal}
        Children={
          <ModalInformation
            accept={handleClick}
            cancel={handleClose}
            title={t2('EditModule')}
            message={t2('Confirmation')}
          />
        }
      />
      <Alert message={alertMessage} open={alertOpen} setOpen={setAlertOpen} />
    </div>
  );
}

export default ModuleData;
